import React from 'react'
import './table.css'
export const CustomTable = ({ headers, children, id, onClickSort }) => {
    return (
        <table className="table table-gd table-hover table-ux-ui w-100" id={id} >
            <thead>
                <tr className="table-col-names text-center">
                    {
                        headers.map((header, idx) => (
                            header?.order ?
                                <th
                                    scope='col'
                                    key={idx}
                                >
                                    <div
                                        type='button'
                                        onClick={() => onClickSort(header.columnOrder)}
                                    >
                                        {header.key}
                                        <i
                                            style={{ color: 'var(--gray-500)' }}
                                            className={`ms-1 fa-solid ${header.order === 'ASC' ? 'fa-arrow-up' : 'fa-arrow-down'} `}
                                        >
                                        </i>
                                    </div>
                                </th>
                                :
                                <th
                                    scope='col'
                                    key={idx}
                                >
                                    {header.key}
                                </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
    )
}